<template>
  <div class="betslip" :class="{ showBetslip: shows }">
    <Loading v-if="isLoadingPage"></Loading>
    <div v-else class="betslip__wrap">
      <div class="betslip__title">
        <p>{{ getTranslatedText("your Betslip") }}</p>
      </div>
      <p class="betslip_error" v-if="errorBetslip && tab === 1">
        {{ getTranslatedText(errorBetslip) }}
      </p>
      <div class="betslip__tab">
        <v-card>
          <template>
            <v-tabs v-model="tab">
              <v-tab
                v-for="(item, index) in itemsTab"
                :key="index"
                :disabled="item.isTabDisabled"
              >
                {{ getTranslatedText(item.item) }}
              </v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
                <div
                  class="betslip__tab--content"
                  v-for="(item, index) in dataBetslip"
                  :key="index"
                  :class="{ bet_error: item.itemErrorCutoff }"
                >
                  <p class="betslip__tab--content--date">
                    {{ $helpers.formatDateTime(item.draw_date) }}
                  </p>
                  <div class="betslip__tab--content--title">
                    <p>
                      {{
                        getTranslatedText(
                          `${item.draw_name} - ${item.regualName}`
                        )
                      }}
                    </p>
                    <ul v-if="item?.selected_numbers">
                      <li v-for="(value, i) in item.selected_numbers" :key="i">
                        {{ value }}
                      </li>
                    </ul>
                    <div class="betslip__tab--content--title--type" v-if="item?.selected_game">
                      <span>{{ getTranslatedText('Type') }} </span>
                      <p>{{ item?.selected_game?.name }}</p>
                    </div>
                  </div>
                  <p class="betslip__tab--content--odds">
                    <span>{{ getTranslatedText("odds") }}</span>
                    <span>{{ renderPrice(item.odds) }}</span>
                  </p>
                  <div class="betslip__tab--content--bet">
                    <label>{{ getTranslatedText("Bet Amount:") }}</label>
                    <p :class="{ input_error: item.error_Bet }">
                      <PriceInput
                        :dataInput="renderPrice(item.betAmount)"
                        :index="index"
                        :roundedNumber="item.roundedNumber"
                        :minNumber="item.min"
                        nameFunction="value-price-singleBet"
                        ref="priceInputSingBet"
                      />
                      <span class="bet_erorr" v-if="item.error_Bet">{{
                        getTranslatedText(item.error_Bet)
                      }}</span>
                    </p>
                  </div>
                  <p class="betslip__tab--content--winnings">
                    <span>{{ getTranslatedText("Potential Winnings:") }}</span>
                    <span>{{ renderPrice(item.potential_winings) }}</span>
                  </p>
                  <p
                    class="betslip__tab--content--close"
                    @click="handleClearItem(index)"
                  >
                    <img src="~ThemePath/images/icon/icon_remove.png" alt="" />
                  </p>
                </div>
                <div
                  class="betslip__tab--betamount"
                  v-if="dataBetslip.length !== 0"
                >
                  <p>
                    <span>{{ getTranslatedText("Bet Amount:") }}</span>
                    <span>{{ renderPrice(singleAmount) }}</span>
                  </p>
                </div>
                <div class="betslip__tab--emtpy" v-else>
                  <p>
                    {{
                      getTranslatedText(
                        "Your betslip is empty. Please place your bet."
                      )
                    }}
                  </p>
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <div
                  class="betslip__tab--content"
                  v-for="(item, index) in dataBetslip"
                  :key="index"
                  :class="{ bet_error: item.itemError || item.itemErrorCutoff }"
                >
                  <p class="betslip__tab--content--date">
                    {{ $helpers.formatDateTime(item.draw_date) }}
                  </p>
                  <div class="betslip__tab--content--title">
                    <p>
                      {{
                        getTranslatedText(
                          `${item.draw_name} - ${item.regualName}`
                        )
                      }}
                    </p>
                    <ul v-if="item?.selected_numbers">
                      <li
                        v-for="(number, index) in item.selected_numbers"
                        :key="index"
                      >
                        {{ number }}
                      </li>
                    </ul>
                    <div class="betslip__tab--content--title--type" v-if="item?.selected_game">
                      <span>{{ getTranslatedText('Type') }} </span>
                      <p>{{ item?.selected_game?.name }}</p>
                    </div>
                  </div>
                  <p class="betslip__tab--content--odds">
                    <span>{{ getTranslatedText("odds") }}</span>
                    <span>{{ renderPrice(item.odds) }}</span>
                  </p>
                  <p
                    class="betslip__tab--content--close"
                    @click="handleClearItem(index)"
                  >
                    <img src="~ThemePath/images/icon/icon_remove.png" alt="" />
                  </p>
                </div>
                <div
                  class="betslip__tab--betamount"
                  v-if="dataBetslip.length !== 0"
                >
                  <p>
                    <span>{{ getTranslatedText("Total Odds:") }}</span>
                    <span>{{ renderPrice(multiOdds) }}</span>
                  </p>
                  <p class="betslip__error" v-if="invalidPotent">
                    {{ getTranslatedText(invalidPotent) }}
                  </p>
                  <p class="bet_winnings" :class="{ bet_error: invalidPotent }">
                    <span>{{ getTranslatedText("Potential Winnings:") }}</span>
                    <span>{{ renderPrice(multiWinners) }}</span>
                  </p>
                  <p class="bet_amount">
                    <span>{{ getTranslatedText("Bet Amount:") }}</span>
                    <label :class="{ input_error: invalidMultiBet }">
                      <span v-if="invalidMultiBet" class="bet_erorr">{{
                        getTranslatedText(invalidMultiBet)
                      }}</span>
                      <PriceInput
                        :dataInput="renderPrice(multiAmount)"
                        :roundedNumber="legZeroMultibet?.roundedNumber"
                        :minNumber="legZeroMultibet?.min"
                        nameFunction="value-price-multiBet"
                      />
                    </label>
                  </p>
                </div>
                <div class="betslip__tab--emtpy" v-else>
                  <p>
                    {{
                      getTranslatedText(
                        "Your betslip is empty. Please place your bet."
                      )
                    }}
                  </p>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
      <div class="betslip__button" v-if="dataBetslip.length !== 0">
        <ButtonCommon
          :isNoHover="true"
          text="Clear All"
          @action-button="handleClearAll()"
          className="betslip_clear"
        />
        <ButtonCommon
          :isNoHover="true"
          text="Add To Checkout"
          @action-button="addToCheckout()"
          className="betslip_add"
          :isLoading="isLoadingButton"
        />
      </div>
      <div class="betslip__close" @click="handleToggleBetslip">
        <img src="~ThemePath/images/icon/icon_close_blue.svg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from "@/utils/EventBus";
import languageMixins from "@/mixins/language/language-mixins";
import errorDeviceMinxins from "@/mixins/errorDevice/errorDevice-mixins";
import configGameMinxins from "@/mixins/configGame/configGame-mixins";
import ButtonCommon from "@/components/common/button";
import PriceInput from "@/components/common/priceInput";
import {formatPrice, isObjEmpty} from "@/utils/utils";
import Loading from "@/components/common/loading";
import GamesService from "@/services/games.service";

const MAXIMUM_MULTIBET = process.env.VUE_APP_MAXIMUM_MULTIBET;
const CROSSGAME = process.env.VUE_APP_ENABLE_MULTIBET_CROSSGAME
const TIME_ZONE = process.env.VUE_APP_TIME_ZONE;
const CURRENCY_SYMBOL = process.env.VUE_APP_CURRENCY_SYMBOL;

export default {
  mixins: [languageMixins, errorDeviceMinxins, configGameMinxins],
  components: { ButtonCommon, PriceInput, Loading },
  data() {
    return {
      shows: false,
      tab: null,
      legZeroMultibet: {},
      multiAmount: 0,
      invalidMultiBet: false,
      invalidPotent: false,
      valuefilter: {},
      errorBetslip: false,
      maxMultibet: this.$store.state.configAccount?.settings.MAX_MULTIBET_POTENTIAL_WINNINGS_LIMIT ?
          this.$store.state.configAccount?.settings.MAX_MULTIBET_POTENTIAL_WINNINGS_LIMIT
          : MAXIMUM_MULTIBET,
      CURRENCY:this.$store.state.configAccount?.settings.CURRENCY_SYMBOL ? this.$store.state.configAccount?.settings.CURRENCY_SYMBOL : CURRENCY_SYMBOL,
      isLoadingButton: false,
      isLoadingPage: false,
      dataGames:'',
    };
  },
  created() {
    this.fetchDataGames();
    EventBus.$on("eventBetslip", this.handleToggleBetslip);
    EventBus.$on("clear-all-betslip", this.clearAllBetslip);
    EventBus.$on("clear-item-betslip", (index) => {
      this.clearItemBetslip(index);
    });
    EventBus.$on("value-price-singleBet", (value, index) => {
      this.handleInputPrice(value, index);
    });
    EventBus.$on("value-price-multiBet", (value) => {
      this.muitiInputBet(value);
    });
  },
  destroyed() {
    EventBus.$off("eventBetslip");
    EventBus.$off("clear-all-betslip");
    EventBus.$off("clear-item-betslip");
    EventBus.$off("value-price-singleBet");
    EventBus.$off("value-price-multiBet");
  },
  mounted() {
    this.getFilteredValues();
  },
  computed: {
    dataBetslip() {
      return this.$store.state.dataBetslip;
    },
    singleAmount() {
      return this.dataBetslip.reduce(
        (total, item) => total + item.betAmount,
        0
      );
    },
    multiOdds() {
      return this.dataBetslip.reduce((total, item) => total * item.odds, 1);
    },
    multiWinners() {
      return this.multiAmount * this.multiOdds;
    },
    showGameLoto() {
      return this.$route.meta.isGame;
    },
    itemsTab() {
      let configIndex = 0;
      if (this.$route.meta.isGame === "loto-vert") {
        configIndex = 1;
      } else if (this.$route.meta.isGame === "loto-plus") {
        configIndex = 2;
      }

      const data = [
        { item: "Singlebet", isTabDisabled: false },
        {
          item: "Multibet",
          isTabDisabled: !this.configGame[configIndex].multi_bet
        },
      ];
      return data;
    },
  },

  methods: {
    async fetchDataGames() {
      try {
        this.isLoadingPage = true;
        const res = await GamesService.getListGame();
        if (res.status === "success") {
          this.dataGames = res.data;
        } else {
          console.log(res)
        }
        this.isLoadingPage = false;
        this.handleCheckBetslip();

      } catch (error) {
        console.log(error);
        this.isLoadingPage = false;
      }
    },
    handleToggleBetslip() {
      this.shows = !this.shows;
    },
    renderPrice(price) {
      return formatPrice(price);
    },
    handleInputPrice(value, index) {
      this.dataBetslip[index].betAmount = value;
      this.isBetAmountInvalid(index);
      this.dataBetslip[index].potential_winings = this.handlePotential(
        value,
        this.dataBetslip[index].odds
      );
    },
    isBetAmountInvalid(index, notications = false) {
      const betAmount = this.dataBetslip[index].betAmount;
      const min = this.dataBetslip[index].min;
      const max = this.dataBetslip[index].max;
      const roundedNumber = this.dataBetslip[index].roundedNumber ? this.dataBetslip[index].roundedNumber : 10;
      if(!notications){
        if (min > betAmount) {
        this.dataBetslip[index].error_Bet = `Min is ${this.renderPrice(min)}`;
        } else if (max < betAmount) {
          this.dataBetslip[index].error_Bet = `Max is ${this.renderPrice(max)}`;
        } else {
          this.dataBetslip[index].error_Bet = false;
        }
      } else {
          if (min > betAmount) {
              return `The minimum wager is ${this.CURRENCY} ${min} and must be incremented in multiples of ${this.CURRENCY} ${roundedNumber}`;
            } else if (max < betAmount) {
              return `The maximum wager is ${this.CURRENCY} ${max} and must be incremented in multiples of ${this.CURRENCY} ${roundedNumber}`;
            }
        }
    },
    muitiInputBet(value) {
      this.multiAmount = value;
      localStorage.setItem('multiAmount', value)
      this.isInvalidMultiBet();
    },
    handlePotential(betAmount, odds) {
      return betAmount * odds;
    },
    handleClearAll() {
      const param = {
        title: "CONFIRM",
        status: "confirm",
        description: "Do you want to delete all betslip ?",
        nameFunction: "clear-all-betslip",
      };
      if (this.dataBetslip.length) {
        EventBus.$emit("on-show-notications", param);
      }
    },
    handleClearItem(index) {
      const param = {
        title: "CONFIRM",
        status: "confirm",
        description: "Do you want to delete this item ?",
        nameFunction: "clear-item-betslip",
        paramFunction: index.toString(),
      };
      EventBus.$emit("on-show-notications", param);
    },
    handleCheckBetslip() {
      const enableMultipleBetCrossGame = !isObjEmpty(this.$store.state.configAccount)
        ? !this.$store.state.configAccount?.enableMultipleBetCrossGame
        : CROSSGAME === 'false';
      let slugGames;
      switch(this.showGameLoto) {
        case 'loto':
          slugGames = this.slugGames[0]
          break;
        case 'loto-vert':
          slugGames = this.slugGames[1]
          break;
        case 'loto-plus':
          slugGames = this.slugGames[2]
      }
      const firstGame = this.dataBetslip[0]?.game.slug;
      const isAllGamesSame =
        this.dataBetslip.length === 1 ||
        this.dataBetslip.every((item) => item.game.slug === firstGame);

      const countMap = new Map();
      this.dataBetslip.forEach((item) => {
        countMap.set(
          item.game.name + item.draw_date,
          (countMap.get(item.game.name + item.draw_date) || 0) + 1
        );
      });
      this.dataBetslip.forEach((item) => {
        //reset itemErrorCutoff error value before test execution
        item.itemErrorCutoff = false;
        // <--/>

        item.itemError = false;
        const count = countMap.get(item.game.name + item.draw_date);
        if (enableMultipleBetCrossGame) {
          item.itemError = item.game.slug !== slugGames;
        }
        if (isAllGamesSame) {
          item.itemError = false;
        }
        if (count > 1) {
          item.itemError = true;
        }
        this.dataGames.forEach((e) => {
          if (item?.game?.slug === e?.game?.slug) {
            const hasMarket = e.markets?.some((market) => market.market_slug === item.market_slug)
            if(!hasMarket) item.itemErrorCutoff = true;
          }
        })
      });

      this.errorBetslip = this.dataBetslip.some((item) => item.itemError)
        ? "Not allow multiple market per draw for multiple bet."
        : false;
      this.isInvalidMultiBet();

      // check itemErrorCutoff
      this.checkConfigGame();
      // this.checkDateBetslip();
      // <--/>
    },
    getFilteredValues() {
      let filteredValues = {
        // defaultBet: 0,
        maxBet: Number.POSITIVE_INFINITY,
        // minBet: 0,
      };
      this.legZeroMultibet = this.handleGetMin(this.dataBetslip);
      this.dataBetslip.forEach((object) => {
        // if (
        //   object.draw_Reguar.config.wager.display_min >
        //   filteredValues.defaultBet
        // ) {
        //   filteredValues.defaultBet =
        //     object.draw_Reguar.config.wager.display_min;
        // }
        filteredValues.maxBet = Math.min(filteredValues.maxBet, object.max);
        // filteredValues.minBet = Math.max(filteredValues.minBet, object.min);
      });
      this.valuefilter = filteredValues;
      const changedAmountMultibet = localStorage.getItem('multiAmount') ? localStorage.getItem('multiAmount') : false
      if(this.dataBetslip.length === 0 && changedAmountMultibet){
        localStorage.removeItem('multiAmount')
      }else if(changedAmountMultibet){
        this.multiAmount = changedAmountMultibet;
      }else{
        this.multiAmount = this.legZeroMultibet?.min;
      }
    },
    isInvalidMultiBet(notications) {
      if (this.multiAmount > this.valuefilter.maxBet) {
        this.invalidMultiBet = `Max is ${this.renderPrice(
          this.valuefilter.maxBet
        )}`;
      } else if (this.multiAmount < this.legZeroMultibet?.min) {
        this.invalidMultiBet = `Min is ${this.renderPrice(
            this.legZeroMultibet?.min
        )}`;
      } else {
        this.invalidMultiBet = false;
      }
      if (this.multiWinners > this.maxMultibet) {
        this.invalidPotent = `Max is ${this.renderPrice(this.maxMultibet)}`;
      } else {
        this.invalidPotent = false;
      }

      if(notications){
        if (this.legZeroMultibet?.min > this.multiAmount) {
          return `The minimum wager is ${this.CURRENCY} ${this.legZeroMultibet?.min} and must be incremented in multiples of ${this.CURRENCY} ${this.legZeroMultibet.roundedNumber}`;
        } else if (this.valuefilter.maxBet < this.multiAmount) {
          return `The maximum wager is ${this.CURRENCY} ${this.valuefilter.maxBet} and must be incremented in multiples of ${this.CURRENCY} ${this.legZeroMultibet.roundedNumber}`;
        }
      }
    },
    // checkDateBetslip() {
    //   const currentDate = this.$helpers.changeTimeZone(new Date(), TIME_ZONE);
    //   let specificDate;
    //   let resultCheck = true;
    //   this.dataBetslip.forEach((item) => {
    //     specificDate = this.$helpers.changeTimeZone(
    //       new Date(item.cutoff),
    //       TIME_ZONE
    //     );
    //     if (specificDate < currentDate) {
    //       resultCheck = false;
    //       item.itemErrorCutoff = true;
    //     }
    //   });
    //   return resultCheck;
    // },
    checkConfigGame() {
      // if (!this.configGame[0].enabled) {
      //   this.dataBetslip.forEach((item) => {
      //     if (item.game.slug === this.slugGames[0]) {
      //       item.itemErrorCutoff = true;
      //     }
      //   });
      // }
      // if (!this.configGame[1].enabled) {
      //   this.dataBetslip.forEach((item) => {
      //     if (item.game.slug === this.slugGames[1]) {
      //       item.itemErrorCutoff = true;
      //     }
      //   });
      // }
      for (let i = 0; i < this.configGame?.length; i++){
        if (!this.configGame[i].enabled) {
          this.dataBetslip.forEach((item) => {
            if (item.game.slug === this.slugGames[i]) {
              item.itemErrorCutoff = true;
            }
          });
        }
      }
      return !this.dataBetslip.some((item) => item.itemErrorCutoff === true);
    },
    addToCheckout() {
      if(this.tab === 1 && ((Number(this.multiAmount) - this.legZeroMultibet.min) % this.legZeroMultibet.roundedNumber)!== 0) {
        return EventBus.$emit("on-show-notications", {
          title: `The amount ${this.multiAmount} is not incremented by ${this.legZeroMultibet.roundedNumber}. Please update the amount!`,
          status: "error",
        });
      }
      let dataAddCheckout;
      const hasErrorBet = this.dataBetslip.some((item) => item.error_Bet !== false)
      const param = {
        title: "",
        status: "error",
        description: "Please Try Again",
      };
      this.isLoadingButton = true;
      this.$store
        .dispatch("fetchDataConfig")
        .then((res) => {
          this.isLoadingButton = false;
          if (
            this.tab === 0 && !hasErrorBet
          ) {
            dataAddCheckout = this.dataBetslip.map((item) => ({
              ...item,
              typeGame: 1,
            }));
          } else if (
            this.tab === 1 &&
            !this.invalidMultiBet &&
            !this.errorBetslip &&
            !this.invalidPotent
          ) {
            if (this.dataBetslip.length > 1) {
              dataAddCheckout = {
                typeGame: 2,
                totalOdds: this.multiOdds,
                potentialWining: this.multiWinners,
                betAmount: this.multiAmount,
                data: this.dataBetslip,
                itemErrorCutoff: false,
              };
            } else {
              dataAddCheckout = this.dataBetslip.map((item) => ({
                ...item,
                betAmount: this.multiAmount,
                typeGame: 1,
              }));
            }
          } else {
            if (this.tab === 0 && hasErrorBet){
              const indexErrorBet = this.dataBetslip.findIndex(item => item.error_Bet !== false);
              param.title = this.isBetAmountInvalid(indexErrorBet, true)
            } else if (this.tab === 1 && this.errorBetslip) {
              param.title = this.errorBetslip;
            } else if (this.tab === 1 && this.invalidPotent) {
              param.title = `Max winning allowed is ${this.renderPrice(
                this.maxMultibet
              )}.`;
              param.description = "Please enter a smaller bet amount";
            } else if (this.tab === 1 && this.invalidMultiBet){
              param.title = this.isInvalidMultiBet(true)
            }
            EventBus.$emit("on-show-notications", param);
            return;
          }
          // if (!this.checkDateBetslip()) {
          //   param.title = "The date you selected has expired";
          // } else
          if (!this.checkConfigGame()) {
            param.title = "the game you selected has been disabled";
          } else {
            this.$store.dispatch("addToCheckout", dataAddCheckout);
            this.clearAllBetslip();
            this.handleToggleBetslip();
            this.$router.push({ name: "Checkout" });
            return;
          }
          EventBus.$emit("on-show-notications", param);
          this.checkErrorDevice(this.$router, res)
        })
        .catch((error) => {
          this.isLoadingButton = false;
          param.title = error.data?.errors
          ? error.data.errors.map(item => item.message).join(', ')
          : error.message;
          EventBus.$emit("on-show-notications", param);
          this.checkErrorDevice(this.$router, error)
        });
    },
    clearAllBetslip() {
      this.$store.dispatch("clearAllBetslip");
    },
    clearItemBetslip(index) {
      this.$store.dispatch("clearItemBetslip", index);
    },
    handleGetMin(draws) {
      return draws.reduce((min, draw) => {
        const drawDate = new Date(draw.draw_date);
        return drawDate < new Date(min.draw_date) ? draw : min;
      }, draws[0]);
    }
  },
  watch: {
    dataBetslip() {
      this.legZeroMultibet = this.handleGetMin(this.dataBetslip);
      this.getFilteredValues();
      this.handleCheckBetslip();
      this.$nextTick(() => {
        this.dataBetslip.forEach((item, i) => {
          this.$refs.priceInputSingBet[i].inputValue = this.renderPrice(item.betAmount);
        });
      });
      if (this.tab === 1 && this.dataBetslip) {
        if (this.multiAmount < this.legZeroMultibet?.min) {
          this.isInvalidMultiBet(true);
        }
      }
    },
    showGameLoto() {
      this.handleCheckBetslip();
    },
    itemsTab(){
      if(this.itemsTab[1].isTabDisabled){
        this.tab = 0
      }
    },
    deep: true,
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/common/_betslip.scss";
</style>
